import React from "react";

import type { ReactNode } from "react";

const Background: React.FC<{ children: ReactNode }> = ({ children }) => (
  <>{children}</>
);

export default Background;
